<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small-medium"
            @close="close"
			:hideFooter="true"
            v-if="isShowGenerateInvoice">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Generate Custom Invoice') }}</h5>
            </template>
            <template slot="body">
				<div>
					<form @submit.prevent="generateInvoice">
						<div class="d-flex">
							<!-- amount -->
							<div class="form-group col-md-6 ml-0 pl-0">
								<label>{{ $t('Amount') }}(USD)</label>
								<input type="number" name="amount" class="form-control" v-model="amount" required>
							</div>
							<!-- discount -->
							<div class="form-group col-md-6 ml-2 pl-2 mr-0 pr-0">
								<label>{{ $t('Discount (%)') }}</label>
								<input min=0 max=100 oninput="validity.valid||(value='');" type="number"  name="discount" class="form-control" v-model="discount">
							</div>
						</div>
						<div class="d-flex">
							<!-- date -->
							<div class="col-md-6 col-md-6 ml-0 pl-0">
								<div class="form-group">
									<label>{{ $t('Date Issued') }}</label>
									<flat-pickr
										class="date-event form-control"
										:config="configDateTimePicker"
										v-model="date"
									/>
								</div>
							</div>
							<div class="col-md-6 ml-2 pl-2 mr-0 pr-0">
								<div class="form-group roles">
									<label>{{ $t('Payment Method') }}</label>
									<multiselect class="roles-input" v-model="paymentMethod" tag-placeholder="Add Method"
										label="label" track-by="key"
										:options="paymentMethods"  :multiple="false" :searchable="false" :show-labels="false">
										<span class="arrow-multiselect" slot="caret">
											<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
										</span>
									</multiselect>
								</div>
							</div>
						</div>
						<!-- Description -->
						<div class="form-group">
							<label>{{ $t('Description') }}</label>
							<textarea type="text" name="description" rows="10" class="form-control" maxlength="455"
							v-model="description" required>
							</textarea>
						</div>
						<div>
						<div class="form-group roles mt-2 mb-2">
							<label>{{ $t('Send To') }}</label>
							<multiselect class="roles-input" v-model="userId" tag-placeholder="Add User"
								placeholder="Search or add a user" label="name" track-by="id"
								:options="filteredUser"  :multiple="false" :searchable="true" :show-labels="false">
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No Users found.</span></multiselect>
							</div>
						</div>
						<!-- Is Published -->
						<!-- <div class="d-flex">
							<md-switch
								class="md-primary mt-0 mb-3 mr-3"
								v-model="isAddToUser">
								{{ $t('Add Invoice to User\'s Billing') }}
							</md-switch>
						</div> -->
						<!-- Submit -->
						<button
							:disabled="!isValid"
							type="submit"
							:class="{'is-loading': isGenerateInvoice}"
							class="btn btn-primary mt-3">
							{{ $t('Generate Invoice') }}
						</button>
					</form>
				</div>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
	</div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import dayjs from 'dayjs';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import usersApi from '@/api/user';
import transactionsApi from '@/api/transactions';


import {
	getAxiosErrorMessage,
} from '@/lib/helper';

export default {
	name: 'ModalGenerateInvoice',
	components: {
		Modal,
		Multiselect,
		flatPickr,
	},
	props: {
		data: {
			type: Object,
		},
		titleAssignModal: {},
		isShowGenerateInvoice: {
			type: Boolean,
			default: false,
		},
	},
	mounted() {
	},
	data: () => ({
		page: 1,
		limit: 10,
		lastPage: 1,
		totalItems: 1,
		orderBy: 'created_at',
		sortBy: 'desc',
		keyword: '',
		users: [],
		userId: [],
		assignedUser: [],
		isFetchingUsers: false,
		isOpenModalListAssignedUser: false,
		isGetAssignUsers: false,
		hover: false,
		hoverItem: null,
		isConfirmRemoveVisible: false,
		selected: '',
		isUnAssignUsers: false,
		isGenerateInvoice: false,
		configDateTimePicker: {
			enableTime: false,
			dateFormat: 'Y-m-d',
			minDate: 'today',
		},
		isAddToUser: true,
		paymentMethod: { key: 'Bank Transfer', label: 'Bank Transfer' },
		description: '',
		date: dayjs(new Date()).format('YYYY-MM-DD'),
		discount: 0,
		amount: '',
		paymentMethods: [
			{ key: 'Bank Transfer', label: 'Bank Transfer' },
			{ key: 'Cash', label: 'Cash' },
			{ key: 'Others', label: 'Others' },
		],
	}),
	methods: {
		close() {
			this.$emit('close');
		},
		reset() {
			this.amount = '';
			this.discount = '';
			this.date = '';
			this.paymentMethod = '';
			this.description = '';
			this.userId.id = '';
			this.isAddToUser = true;
		},
		fetchUsers() {
			this.isFetchingUsers = true;
			const callback = (response) => {
				const items = response.data;
				this.users = items;
				this.isFetchingUsers = false;
				if (this.data) {
					const index = this.users.findIndex(({ id }) => id === this.data.user_id);
					this.userId = this.users[index];
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetchingUsers = false;
			};
			const params = {
				page: 1,
				limit: 9999,
			};
			usersApi.getUsers(params, callback, errorCallback);
		},
		generateInvoice() {
			this.isGenerateInvoice = true;
			const callback = (response) => {
				this.isGenerateInvoice = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Users',
					text: response.message,
				});
				this.isGenerateInvoice = false;
				this.reset();
				this.$emit('add', response.data);
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isGenerateInvoice = false;
			};
			transactionsApi.generateInvoice(this.generateParams, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
		}),
		filteredUser() {
			const filter = item => (!item.roles.includes('super_admin'));
			return this.users.filter(filter);
		},
		generateParams() {
			const params = {
				amount: this.amount,
				discount: this.discount,
				date: this.date,
				payment_method: this.paymentMethod && this.paymentMethod.key ? this.paymentMethod.key : '',
				description: this.description,
				user_id: this.userId.id,
				is_add_to_user: this.isAddToUser,
			};
			return params;
		},
		isValid() {
			return 	this.amount !== ''
			&& this.date !== ''
			&& this.paymentMethod && this.paymentMethod.length !== 0
			&& this.description !== ''
			&& this.userId && this.userId.length !== 0;
		},
	},
	created() {
		this.fetchUsers();
	},
};
</script>

<style>
.assigned-user-modal{
	min-height: 500px!important;
}
</style>
